import { TOKENS_COLOR_DEFAULT } from '../tokens-default.generated.js';
export const LOADING_FIELDS = [
    {
        key: 'loading.indicator.color',
        label: '로딩 표시 색',
        help: '목록·화면을 불러오는 동안 도는 로딩 표시의 색(아이콘 색 토큰)입니다. 색을 따로 정한 곳(영상·사진 위의 흰색 등)은 그 색을 따릅니다. 토큰의 실제 색은 라이트·다크 테마마다 다릅니다.',
        group: '로딩 표시',
        type: 'enum',
        defaultValue: 'neutral-tertiary',
        options: Object.keys(TOKENS_COLOR_DEFAULT.light.icon).map((name) => ({
            value: name,
            label: `icon.${name}`,
        })),
    },
    {
        key: 'loading.progress.size',
        label: '결제 진행 원 크기',
        help: '결제를 처리하는 동안 화면 가운데에 도는 원형 진행 표시의 지름입니다.',
        group: '원형 진행 표시',
        type: 'size',
        tokenGroup: 'dimension',
        defaultValue: '$dimension.3xl',
        min: 24,
        max: 160,
    },
    {
        key: 'loading.progress.strokeWidth',
        label: '결제 진행 원 선 굵기',
        help: '원형 진행 표시의 선 굵기입니다.',
        group: '원형 진행 표시',
        type: 'size',
        tokenGroup: 'dimension',
        defaultValue: 4,
        min: 1,
        max: 12,
    },
    {
        key: 'loading.progress.cycleMs',
        label: '결제 진행 원 한 바퀴 시간',
        help: '원형 진행 표시가 한 바퀴 도는 시간입니다. 작을수록 빨리 돕니다.',
        group: '원형 진행 표시',
        type: 'integer',
        defaultValue: 1200,
        min: 400,
        max: 4000,
        unit: 'ms',
    },
    {
        key: 'loading.skeleton.pulseMs',
        label: '스켈레톤 깜빡임 시간',
        help: '홈 배너를 불러오는 동안 보이는 회색 자리 표시(스켈레톤)가 흐려졌다 진해지는 데 걸리는 시간입니다.',
        group: '스켈레톤',
        type: 'integer',
        defaultValue: 800,
        min: 200,
        max: 3000,
        unit: 'ms',
    },
    {
        key: 'loading.skeleton.minOpacity',
        label: '스켈레톤 가장 흐린 정도',
        help: '스켈레톤이 깜빡일 때 가장 흐린 순간의 불투명도입니다. 100이면 깜빡이지 않습니다.',
        group: '스켈레톤',
        type: 'integer',
        defaultValue: 50,
        min: 0,
        max: 100,
        unit: '%',
    },
];
//# sourceMappingURL=loading.js.map